import { AxiosHttpClientNoRedirect } from '../../../infra/http/axios-http-client-no-redirect/axios-http-client-no-redirect'
import { settings } from '../../configs/settings'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const makeAxiosHttpClient = () => new AxiosHttpClientNoRedirect(settings.API_URL)
